export function convertDateFormat(dateString) {
  try {
    const dateObj = new Date(dateString);

    const day = dateObj.getDate();
    const month = dateObj.getMonth();
    const year = dateObj.getFullYear();

    const formattedDay = day.toString().padStart(2, "0");
      const monthNames = ["January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"];
    const formattedMonth = monthNames[month];

    const formattedDate = `${formattedDay} ${formattedMonth} ${year}`;

    return formattedDate;
  } catch (error) {
    console.error("Invalid date format. Please provide a valid ISO 8601 string.");
    return null;
  }
}